import React, { useState, useEffect } from 'react';  
import { useSelector } from 'react-redux';
import { RootState } from '../store/store'; 
import { getUserMenu ,getUserProfile} from '../reducers/settingsReducer';   
import { useAppDispatch } from '../hooks/useAppDispatch';
import Footer from '../components/footer';
import Header from '../components/header';
interface SharedLayoutProps {
  children: React.ReactNode;
}  

export interface MenuProps {
    section: string;
    icon: string;
    permissions: MenuItem[];
}  

interface MenuItem {
name: string; 
icon: string; 
pages: {
    page: string;
    singlePage: string | null;
};
}

const SharedLayout: React.FC<SharedLayoutProps> = ({ children }) => { 
  const dispatch = useAppDispatch(); 
  const menuData = useSelector((state: RootState) => state.settings.menu);
  const profile = useSelector((state: RootState) => state.settings.profile);
  const authToken = useSelector((state: RootState) => state.auth.token); 
  useEffect(() => { 
    if (authToken) {
       dispatch(getUserMenu()); 
      // dispatch(getUserProfile()); 
    }
  }, [dispatch, authToken]); 
 
  const MenuProps: MenuProps[] = Array.isArray(menuData.data) ? menuData.data : [];   
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {authToken && <Header profile={profile.data}  menuData={MenuProps}/>}
      {/* {authToken && <Navbar menuData={MenuProps} />}   */}
      <main style={{ flex: 1 }}>{children}</main>
      <Footer /> 
    </div>
  );
};

export default SharedLayout;
